import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPlannerVisitStatus } from "~/__generated__";

import { WeatherReportsTableHeader } from "../WeatherReportsTableHeader";
import { WeatherConditionValues, WeatherReportTableRow } from "../WeatherReportTableRow";
import { WeatherReportContentFragment } from "./fragment.generated";

type Props = {
    weatherReport: WeatherReportContentFragment | undefined;
    visitStatus: GqlPlannerVisitStatus;
    onUpdate: (values: WeatherConditionValues) => Promise<void>;
};

export default function WeatherReportContent({ weatherReport, visitStatus, onUpdate }: Props) {
    const { t } = useTranslation("project");

    return (
        <Box
            sx={theme => ({
                display: "grid",
                gridTemplateColumns: "2fr 1fr 1fr auto",
                borderBottom: `1px solid ${theme.palette.divider}`,
            })}
        >
            <WeatherReportsTableHeader />
            {weatherReport?.conditions.map(condition => (
                <WeatherReportTableRow
                    key={condition.name}
                    metric={t(`projectReviewVisitV2.weatherReportsRoute.metrics.${condition.name}`)}
                    condition={condition}
                    visitStatus={visitStatus}
                    onUpdate={onUpdate}
                />
            ))}
        </Box>
    );
}
